/*
    Self-service signup is only offered on domains Interfy owns.

    This build is served under every brand hostname and resolves its domain
    from window.location.hostname, so the partner white-label hostnames
    (trify.com.br, doker.cloud, ...) used to render the whole Start Free flow
    and create workspaces on their own brand. admin-api now rejects those with
    403 domain_not_allowed; this hides the flow so visitors never reach the
    dead end -- and, on the legacy site, never leave an orphan customer record
    behind (the customer is created before the workspace and there is no
    rollback call here).

    The server is the enforcement point; admin-api's
    EnsureSelfServiceDomainIsInterfyOwned applies the same 'interfy' rule but
    can be widened by env (SELF_SERVICE_WORKSPACE_DOMAIN_TYPES). If ops ever
    widens it there, this file has to be widened too or the site will keep
    hiding a flow the server would now accept.

    An unresolved domain fails open here but fails closed in the router guard.
    Both are safe: nothing renders at all until the domain lands (App.vue puts
    a `v-if="domain"` on router-view), so the open case has no page to appear
    on, while the guard is what stands between a partner hostname and an
    orphan customer record. A domain that resolves to the interfy
    defaultDomain because /api/domain failed is treated as Interfy, same as
    every other feature on the site -- the server's 403 is the backstop.
*/

export const SIGNUP_DOMAIN_TYPES = ['interfy']

export function isSignupAllowedForDomain(domain) {
    if (!domain || !domain.type) {
        return true
    }

    return SIGNUP_DOMAIN_TYPES.includes(String(domain.type).toLowerCase())
}

// Routes that make up the workspace-creation funnel, without the "-partner"
// suffix that main.js appends to the partner-slug variants of every route.
export const SIGNUP_ROUTE_NAMES = [
    'start-free',
    'start-free-checkout',
    'plans',
    'plans_currency_by_url',
    'checkout',
    'thanks-page',
]

export function isSignupRoute(routeName) {
    if (!routeName) {
        return false
    }

    return SIGNUP_ROUTE_NAMES.includes(String(routeName).replace(/-partner$/, ''))
}
